import gql from 'graphql-tag';

export default gql`
  mutation revokeCalendarFeedSecurityToken($input: revokeHeCalendarFeedSecurityTokenInput!) {
    revokeCalendarFeedSecurityToken(input: $input) {
      viewer {
        id
        calendarFeedSecurityToken
      }
    }
  }
`;
